import { useState } from 'react'
import { Send } from 'lucide-react'

interface Props {
  onSend: (message: string) => void
  disabled?: boolean
}

export default function ChatInput({ onSend, disabled }: Props) {
  const [value, setValue] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!value.trim() || disabled) return
    onSend(value.trim())
    setValue('')
  }

  return (
    <div className="border-t border-gray-200 p-4">
      <form onSubmit={handleSubmit} className={`flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2.5 transition-opacity ${disabled ? 'opacity-50' : ''}`}>
        <input
          type="text"
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder={disabled ? 'Agent is working...' : 'Type a message...'}
          disabled={disabled}
          className="flex-1 bg-transparent text-sm text-gray-900 placeholder-gray-400 outline-none disabled:cursor-not-allowed"
        />
        <button
          type="submit"
          disabled={disabled || !value.trim()}
          className="p-1 text-gray-400 transition-colors hover:text-blue-500 disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <Send className="h-4 w-4" />
        </button>
      </form>
    </div>
  )
}
